import {
  DEFAULT_ICON_PACK,
  MATERIAL_SYMBOLS_FILLED,
  MATERIAL_SYMBOLS_ROUNDED,
} from '@voly/ui-helpers/utility_variables/iconPacks';

import { useIconPack } from './VIconPackProvider.jsx';
import materialSymbolsFilled from './materialSymbolsFilled.jsx';
import materialSymbolsRounded from './materialSymbolsRounded.jsx';

const ICON_PACKS = {
  [MATERIAL_SYMBOLS_FILLED]: materialSymbolsFilled,
  [MATERIAL_SYMBOLS_ROUNDED]: materialSymbolsRounded,
};

const sizes = {
  sm: '1em',
  md: '1.5em',
  lg: '2em',
};

const DEFAULT_SIZE = 'sm';

const VMaterialIcon = ({ name, pack = undefined, size = DEFAULT_SIZE, ...props }) => {
  const providedPack = useIconPack();
  const resolvedPack = pack ?? providedPack ?? DEFAULT_ICON_PACK;
  const Icon = (ICON_PACKS[resolvedPack] ?? ICON_PACKS[DEFAULT_ICON_PACK])[name];

  return <Icon size={sizes[size] ?? size} {...props} />;
};

export default VMaterialIcon;
